export const i18nDefaultConfig = {
  defaultNS: "app",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  returnEmptyString: false,
  returnNull: false,
};
